import React, { useState } from "react";

export const Modal = ({ isOpen, onClose, children }) => {
    return (
        isOpen && (
            <div
                className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-6"
                onClick={onClose} // Закрытие при клике на задний фон
            >
                <div
                    className="bg-fill rounded-lg shadow-lg p-6 w-96"
                    onClick={(e) => e.stopPropagation()} // Предотвращение закрытия при клике внутри модального окна
                >
                    {children}
                </div>
            </div>
        )
    );
};
